function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (comp, auto_join) {
  var html = "\n        <div class=\"call-schedule-join-container saito-overlay-panel\">\n            <h4>Scheduled Calls</h4>\n            <div class=\"scheduled-calls\">";
  var _iterator = _createForOfIteratorHelper(comp.keys),
    _step;
  try {
    var _loop = function _loop() {
      var _call$profile, _call$profile2;
      var call = _step.value;
      var startTime = new Date(call === null || call === void 0 ? void 0 : call.startTime);
      var participants = (call === null || call === void 0 || (_call$profile = call.profile) === null || _call$profile === void 0 ? void 0 : _call$profile.participants) || [];
      var description = (call === null || call === void 0 ? void 0 : call.description) || '';
      if (description) {
        description += '\n\n';
      }
      if (participants) {
        description += 'with: ';
        participants.forEach(function (key) {
          if (key !== comp.mod.publicKey) {
            description += comp.app.keychain.returnUsername(key) + ', ';
          }
        });
        description = description.slice(0, -2);
      }
      var mainBtn = 'Enter';
      if (call !== null && call !== void 0 && (_call$profile2 = call.profile) !== null && _call$profile2 !== void 0 && (_call$profile2 = _call$profile2.participants) !== null && _call$profile2 !== void 0 && _call$profile2.includes(comp.mod.publicKey)) {
        mainBtn = 'Rejoin';
      }
      if (!auto_join) {
        mainBtn = 'Copy Link';
      }
      html += "<div class=\"call-schedule-card-container\" data-id=\"".concat(call.publicKey, "\">\n                    <div class=\"call-schedule-card-item\">Start Time: <span class=\"card-value\">").concat(startTime.toLocaleString(), "</span></div>\n                    <div class=\"call-schedule-card-item\">Duration: <span class=\"card-value\">").concat((call === null || call === void 0 ? void 0 : call.duration) || '', "</span></div>\n                    <div class=\"call-schedule-card-item\">Description: <span class=\"card-value\">").concat(description, "</span></div>\n                    <div class=\"call-schedule-card-item call-countdown\" data-id=\"").concat(call.publicKey, "\">Call starts in...</div>\n                    <div class=\"call-schedule-buttons\">\n                        <button class=\"delete-call-button saito-button-secondary\" data-id=\"").concat(call.publicKey, "\">Delete</button>\n                        <div class=\"enter-call-button saito-button-primary hidden\" data-id=\"").concat(call.publicKey, "\">").concat(mainBtn, "</div>\n                    </div>\n                </div>");
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += "</div>\n            <h4>New Call</h4>\n            <div class=\"enter-call-button saito-button-primary\" id=\"create-new-room\">Create</div>\n        </div>\n    ";
  return html;
};